




























































































import ecPictorialBar from '../../../dv-pure-render/ec-pictorial-bar/ec-pictorial-bar.js';
import lang2d from '../../../utils/lang/lang-2d.js';

import {Vue, Component, Watch, Prop} from 'vue-property-decorator';

@Component({
    components: {}
})
export default class PoiRightPictorialBar extends Vue {
    @Prop()
    data: any;
    lang:any = lang2d;
    pictorialBar:any;
    pictorialBar1: any;
    dataMap = {
        service_serving_speed_score : '上菜',
        dish_recommendation_score: '推荐',
        dish_look_score: '菜色',
        others_overall_experience_score: '感受',
        location_distance_from_business_district_score: '商圈',
        dish_portion_score: '份量',
        price_cost_effective_score: '性价比',
        environment_decoration_score: '装修',
        dish_taste_score: '口感',
        location_easy_to_find_score: '位置',
        service_parking_convenience_score: '泊车',
        price_level_score: '价格',
        environment_cleaness_score: '卫生',
        service_wait_time_score: '排队',
        location_traffic_convenience_score: '交通',
        price_discount_score: '折扣',
        others_willing_to_consume_again_score: '回头客',
        service_waiters_attitude_score: '服务',
        environment_space_score: '空间',
        environment_noiset_score: '安静'
    }

    animation = autoAnimation ? 'fly-out' : 'fly-in';

    @Watch('data', {immediate: true,})
    onDataChange(newVal: any, oldVal: any) {
        Vue.nextTick(() => {
            this.draw();
        });
    }

    draw () {
        if (this.animation === 'fly-out') {
            return void 0;
        }

        let drawData = [];
        if (!this.data) {
            return;
        }
        this.data && this.data.forEach((kv) => {
            let item = {
                name: this.dataMap[kv.field],
                value: kv.value
            };
            drawData.push(item);
        })

        let lfData = drawData.slice(0, 10);
        let rgData = drawData.slice(10);

        let newDrawData = [];
        for(let i = 0; i < 10; i++) {
            newDrawData.push(lfData[i]);
            newDrawData.push(rgData[i]);
        }

        this.destroyChart();
        this.pictorialBar = ecPictorialBar({
            dom: this.$refs.pictorialBarWrap,
            data: newDrawData.slice(0, 10),
            echarts,
        });
         this.pictorialBar1 = ecPictorialBar({
            dom: this.$refs.pictorialBarWrap1,
            data: newDrawData.slice(10),
            echarts,
        });
    }

    destroyChart () {
        this.pictorialBar && this.pictorialBar.destroy();
        this.pictorialBar = null;
        this.pictorialBar1 && this.pictorialBar1.destroy();
        this.pictorialBar1 = null;
    }

    beforeDestroy () {
        this.destroyChart();
    }

    mounted () {
        console.log('poi-right-pictorialBar', 'mounted');
        this.$autoOn('poi-right-pictorialBar', async () => {
            console.log('poi-right-pictorialBar', 'callback');
            this.animation = 'fly-in';
            this.draw();
            await this.$sleep(2100);
        });
    }
}
